<template>
  <article class="game-row" @click="emit('open', row)">
    <div class="game-icon">
      <img :src="row.icon" alt="" />
    </div>
    <div class="game-body">
      <div>{{ row.name }}</div>
      <div class="game-bet">{{ t('promo.rebate.validBet', { amount: fmt(row.betAmount) }) }}</div>
    </div>
    <div class="game-side">
      <div class="game-rate">
        {{ t('promo.rebate.currentRate', { rate: row.rate.toFixed(2) }) }} ›
      </div>
      <div class="game-rebate">{{ fmt(row.rebate) }}</div>
      <!-- 返水池有过期时刻：一天内倒计时，更久显示本地时刻；到点由父级重新拉面板 -->
      <div v-if="row.expireAt" class="game-expire">
        <template v-if="withinDay && remaining !== null">
          ⏳ {{ t('common.time.expiresIn', { countdown: countdown(remaining) }) }}
        </template>
        <i18n-t v-else keypath="common.time.expiresAt" tag="span" scope="global">
          <template #date><LocalTime :value="row.expireAt" /></template>
        </i18n-t>
      </div>
    </div>
  </article>
</template>

<script setup lang="ts">
import { formatBaseAmt } from '~/utils/transfer/money'
import { DAY_MS } from '~/utils/time'
import type { RebateGameRow } from '../types'

const props = defineProps<{ row: RebateGameRow }>()
const emit = defineEmits<{ open: [row: RebateGameRow]; expire: [] }>()

const { t } = useI18n()
const userStore = useUserStore()
const fmt = (n: number) => formatBaseAmt(n, userStore.baseCurrency)

const { countdown } = useTimeDisplay()
const { remaining } = useCountdown(() => props.row.expireAt ?? null, {
  onExpire: () => emit('expire'),
})
const withinDay = computed(() => remaining.value !== null && remaining.value <= DAY_MS)
</script>

<style scoped lang="scss">
.game-row {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 13px 0;
  border-bottom: 1px solid var(--hairline);
  cursor: pointer;
}

.game-icon {
  flex: 0 0 42px;
  width: 42px;
  height: 42px;
  border-radius: var(--r-md);
  overflow: hidden;
  background: var(--surface2);

  img {
    display: block;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
}

.game-body {
  flex: 1;
  min-width: 0;

  b {
    font-size: 14px;
    font-weight: 800;
  }
}

.game-bet {
  font-size: 11px;
  color: var(--muted);
  margin-top: 3px;
}

.game-side {
  text-align: right;
}

.game-rate {
  font-size: 11px;
  color: var(--muted);
}

.game-rebate {
  font-size: 16px;
  font-weight: 900;
  color: var(--success);
  margin-top: 2px;
}

.game-expire {
  font-size: 10.5px;
  color: var(--muted);
  margin-top: 2px;
  font-variant-numeric: tabular-nums;
}
</style>
